export default __webpack_public_path__ + "static/media/GUIÓN SIMULADOR PUNCIÓN_4.2bd79d2a.mp3";